import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Tab,
  Tabs,
} from "@mui/material";
import { PromptInfo } from "./prompt-info";
import { GeneralInfo } from "./general-info";

type InfoDialogProps = {
  open: boolean;
  setClose: () => void;
};

export const InfoDialog = ({ open, setClose }: InfoDialogProps) => {
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const handleTabChange = (
    event: React.SyntheticEvent,
    newValue: number
  ): void => {
    setSelectedTab(newValue);
  };
  return (
    <Dialog open={open} onClose={setClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ backgroundColor: "info.main" }}>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          aria-label="Chat Info tabs"
        >
          <Tab label="General" />
          <Tab label="Prompt Engineering - Tips and Tricks" />
        </Tabs>
      </DialogTitle>
      <DialogContent
        sx={{
          backgroundColor: "info.main",
          paddingRight: 0,
          flexGrow: 1,
          height: "80vh",
        }}
      >
        {selectedTab === 0 && <GeneralInfo />}
        {selectedTab === 1 && <PromptInfo />}
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "info.main",
        }}
      >
        <Button
          onClick={setClose}
          color="secondary"
          sx={{
            ml: 2,
            mb: 1,
          }}
          variant="contained"
        >
          Go to Chat
        </Button>
      </DialogActions>
    </Dialog>
  );
};
